import HelpDeskTypes from 'store/actionTypes/helpDesk'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  languages: {}
}

const helpDesk = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case HelpDeskTypes.GET_HELP_DESKS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case HelpDeskTypes.GET_HELP_DESK_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload?.helpDeskButton
      }
    case HelpDeskTypes.UPDATE_FILTER_HELP_DESK_SUCCESS:
      return { ...state, filter: payload }
    case HelpDeskTypes.UPDATE_HELP_DESK_SELECTED_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: {
          ...state.languages,
          [payload?.id]: payload?.languageId
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default helpDesk
